export default "__VITE_ASSET__D5dNEW6R__"